export default __webpack_public_path__ + "static/media/vhealth-mock2.b8c55b93.png";